<svg width="22" height="2" viewBox="0 0 22 2" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="2" height="2" fill=""/>
<rect x="4" width="2" height="2" fill="currentColor"/>
<rect x="8" width="2" height="2" fill="currentColor"/>
<rect x="12" width="2" height="2" fill="currentColor"/>
<rect x="16" width="2" height="2" fill="currentColor"/>
<rect x="20" width="2" height="2" fill="currentColor"/>
</svg>
